<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.proje_bilgileri"  :show_button="false" ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>




<template v-if="!loading">
<div class="mt-4">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.proje_ismi" :value="item.name" valkey="name" @dataChanged="dataChanged" />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.proje_aktif" :value="item.is_active" valkey="is_active" @dataChanged="dataChanged" />
<ClickEditCalendar :title="$store.state.languages.lang_phrases.proje_baslangici" :value="item.start_date" valkey="start_date" @dataChanged="dataChanged" />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.periyodik_proje" :value="item.is_periodic" valkey="is_periodic" @dataChanged="dataChanged" />
<ClickEditNumber :title="$store.state.languages.lang_phrases.proje_periyodu" :value="item.period" valkey="period" @dataChanged="dataChanged" v-show="item.is_periodic" />
<ClickEditMultiSelect :title="$store.state.languages.lang_phrases.proje_dilleri" :value="item.languages" :options="languages" valkey="languages" @dataChanged="dataChanged"  />
<ClickEditMultiSelect :title="$store.state.languages.lang_phrases.iliskili_ozel_nitelikler" :value="item.customattributes" :options="custom_attributes" valkey="customattributes" @dataChanged="dataChanged"  />







</div>
</template>
</div>



</template>

<script>
export default {

  name: 'ProjectGeneral',

  data () {
    return {
    	item:null,
    	loading:true,
      languages:[],
      custom_attributes:[],
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
    {
        let item = await this.generalApiGetWithoutLoader("project/"+this.$route.params.id)
        item = await this.resolveCustomAttributes(item)
        this.languages = await this.generalApiGetWithoutLoader("languages")
        let custom_attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+item.brand_id)
        for(let attribute of custom_attributes)
        {
          if(attribute.group)
          {
            attribute.name = attribute.name+" ("+attribute.group.name+")"
          }
        }
        this.custom_attributes = custom_attributes
        this.item = await item
        this.loading = await false
    },
    async resolveCustomAttributes(item)
    {
       item.customattributes = await []
        for(let element of item.projectattributes)
        {
          let customattribute = await element.customattribute
          await item.customattributes.push(customattribute)
        }
        return await item
    },
    dataChanged(data)
    {
    	console.log(data.value)
    	console.log(data.key)
    	let formdata = new FormData()
    	
      if(data.key=="languages")
      {
        formdata.append(data.key,JSON.stringify(data.value))
      }
      else if(data.key=="customattributes")
      {
        formdata.append(data.key,JSON.stringify(data.value))
      }
      else
      {
        formdata.append(data.key,data.value)
      }
    	this.generalSubmission(formdata,"project/"+this.item.id,this.afterdataChanged)
    },
    async afterdataChanged(response)
    {
    	console.log("data changed");
    	console.log(response);
      let item = await this.resolveCustomAttributes(response.data)
      this.item =  await item
      await this.$store.dispatch('projects/setProject',this.item)
    	
    }
  }
};
</script>

<style lang="css" scoped>
</style>